function directive() {
    return {
        link: function ($scope, element, attrs) {
            let ioc_att = JSON.parse(attrs.name);
            let div = d3.select(element[0])
            let type = {
                IPType : "IP Address",
                IPSubType : "IP Subnet",
                l7proto : "Layer 7 Protocol",
                FileType : "File Name",
                HashType : "File Hash",
                HTTPType : "HTTP Domain",
                country : "Country",
            }
            let html = "";

            if (attrs.type === "type") {
                for (let i = 0, len = ioc_att.length; i < len; i++) {
                    html += "<hr class='ioc_atts'>"+type[ioc_att[i]]+"</hr>";
                }
            } else {
                for (let i = 0, len = ioc_att.length; i < len; i++) {
                    html += "<hr class='ioc_atts'>"+ioc_att[i]+"</hr>";
                }
            }
            div.html(html)

            $scope.$on('$destroy', function () {
                element.remove();
            });
        }
    };
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/iocattribute/iocattribute.js
 **/